import React, { useCallback, useRef } from 'react';
import clsx from 'clsx';
import Centralizer from '../Centralizer/Centralizer';
import {
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonModal,
  IonToolbar,
} from '@ionic/react';
import { ContactInfoContextType } from './context';
import { closeOutline, copyOutline } from 'ionicons/icons';
import s from './ContactInfoModal.module.scss';
import sg from '../../styles/global.module.scss';
import { useTypedDispatch } from '../../redux/hooks';
import { globalActionCreators } from '../../redux/slices/global/actionCreator';
import { ToastPriorityEnum } from '../../utils/enums';
import ButtonMicroWrapper from '../Buttons/ButtonMicroWrapper/ButtonMicroWrapper';
import { IS_INSTAGRAM } from '../../utils/browser';
import { WHATS_APP_PHONE_NUMBER } from '../../utils/phoneNumber';
import { ContactUsButton } from '../../pages/landing/Components/Sections/Form/Subforms/ContactUsButton';
import { AnalyticEventsEnum, trackEvent } from '../../Analytics';
import { getProductDetailUrl } from '../ProductCard/ProductCard';
import { getBusinessDetailUrl } from '../BusinessCard/BusinessCard';

// TODO ASAP: Introduce experience for Desktop users
// For Assistance page as well
export const ContactInfoModal: React.FC<{
  contactInfoContextData: ContactInfoContextType;
}> = ({ contactInfoContextData }) => {
  const modalRef = useRef<HTMLIonModalElement>(null);

  const dispatch = useTypedDispatch();

  const info = contactInfoContextData?.info;

  const content = info?.product
    ? `Hello, I’m interested in this offering. Could we discuss availability and pricing? \n
https://eventmaker.app${getProductDetailUrl(info.product)}`
    : info?.business
    ? `Hello, I’m interested in some offerings. Could we discuss availability and pricing? \n
https://eventmaker.app${getBusinessDetailUrl(info.business)}`
    : '';

  const link = `https://wa.me/${WHATS_APP_PHONE_NUMBER}?text=${encodeURI(
    content
  )}`;

  const onMessageCopy = useCallback(() => {
    navigator.clipboard.writeText(content || '-');
    dispatch(
      globalActionCreators.setToastObject({
        message: 'Text message copied to clipboard',
        color: 'success',
        priority: ToastPriorityEnum.HIGH,
      })
    );
  }, [dispatch, content]);

  const closeModal = () => contactInfoContextData?.setInfo(undefined);

  return (
    <IonModal
      ref={modalRef}
      // animated={!IS_INSTAGRAM}
      backdropDismiss
      keepContentsMounted
      handle={false}
      isOpen={
        !!contactInfoContextData?.info &&
        !contactInfoContextData.info.isExclusiveAccessModal
      }
      onWillDismiss={event => {
        closeModal();
        if (event.detail.role !== 'submit') {
          trackEvent(AnalyticEventsEnum.MODAL_CLOSED);
        }
      }}
      className={clsx(s.IonModal)}
    >
      <IonHeader>
        <IonToolbar mode="ios">
          <IonButtons slot="end">
            <IonButton
              onClick={() => modalRef.current?.dismiss(undefined, 'close')}
            >
              <IonIcon icon={closeOutline} className={clsx(s.Close__button)} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <div style={{ padding: '10px' }} className={clsx(sg.Stack_Vertical)}>
        <p className={clsx(s.Text__Content)} style={{ padding: '10px 0' }}>
          Send us this message:
        </p>

        <Centralizer>
          <div
            className={clsx(
              sg.Stack_Horizontal,
              sg.Justify_Center,
              sg.Gap_10,
              s.Text__dotted_border
            )}
            style={{ padding: '10px', marginTop: '10px' }}
          >
            <p className={clsx(s.Text__Content)}>{content}</p>

            <ButtonMicroWrapper onClick={onMessageCopy}>
              <IonIcon src={copyOutline} className={clsx(s.IonIcon__copy)} />
            </ButtonMicroWrapper>
          </div>
        </Centralizer>

        <Centralizer>
          <div>
            <ContactUsButton
              style={{ marginTop: '25px' }}
              alignToCenter
              onClick={async () => {
                await trackEvent(AnalyticEventsEnum.LEAD);
                await trackEvent(AnalyticEventsEnum.WHATS_APP_LEAD);
                modalRef.current?.dismiss(undefined, 'submit');
                window.open(link);
              }}
            />
          </div>
        </Centralizer>
      </div>
    </IonModal>
  );
};
